/**
 * Created by tofael on 9/4/18.
 */
import React from 'react';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import {List, ListItem} from 'material-ui/List';
import {grey400} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import MenuItem from 'material-ui/MenuItem';
import config from '../../utility/app-config';
import utils from '../../utility/utils';
import globalStyles from '../../utility/styles';

const styles = {
  root: {

  },
  item: {
    height: '50px',
    padding: '5px',
    cursor: 'pointer',
    marginBottom: '10px'
  },
  header: {
    width: 'inherit',
    margin: '0px -10px 0px -8px'
  },
  history: {
    fontSize: '15px',
    color: '#080808',
    fontWeight: 'bold',
    marginTop: '10px',
    marginBottom: '5px'
  },
  text: {
    margin: '8px',
    height: '20px',
    color: '#000000',
    fontSize: '15px',
    marginTop: '10px',
    marginLeft: '10px',
  },
  date:{
    fontSize: '12px',
    color: '#070707'
  },
};

const ReportList = ({reportList, showReport, deleteReport, className, style}) => {

  const iconButtonElement = (
    <IconButton
      tooltip="Action"
      tooltipPosition="bottom-left"
    >
      <MoreVertIcon color={grey400} />
    </IconButton>
  );

  return (
    <div className={className} style={{...styles.root, ...style}}>
      {
        reportList.length > 0 &&
        <Subheader style={globalStyles.subheader}>Mission Report (s)</Subheader>
      }
      <List>
        {
          [].concat(reportList)
            .sort((a, b)=>{
              return Date.parse(b.created_at) - Date.parse(a.created_at);
            })
            .map((report, index) => (
              <div key={index}>
                <div className="row">
                <div className="col-xs-9 col-lg-9 col-md-9">
                <div style={styles.text}>
                  <span>Report Number: </span>
                  <span>{report.report_number}
                 </span>
                </div>
                {
                  report.file_data && report.file_data.map((data,ind) => (
                    <ListItem
                      key={ind}
                      style={styles.item}
                      leftAvatar={<Avatar size={30} src={data.file_type.split('/')[0] === 'image' ? `${config.urls.doc_url}${data.s3_key}` : '/images/pdf.png'}/>}                      
                      primaryText={`Uploaded at ${utils.toAppDate(report.created_at)}`}
                      onTouchTap={showReport.bind(null, data.s3_key, data.file_type)}
                  />
                    ))
                }
                {
                  (!report.file_data && report.s3_key) && 
                    <ListItem
                      key={index}
                      style={styles.item}
                      leftAvatar={<Avatar size={30} src={report.file_type === 'image' ? `${config.urls.doc_url}${report.s3_key}`: '/images/pdf.png'}/>}
                      primaryText={`Uploaded at ${utils.toAppDate(report.created_at)}`}
                      onTouchTap={showReport.bind(null, report.s3_key, report.file_type)}
                      />
                }
                </div>
                <div className="col-xs-1 col-lg-1 col-md-1">
                <IconMenu iconButtonElement={iconButtonElement}>
                  <MenuItem onTouchTap={deleteReport.bind(null, report.id)}>Delete</MenuItem>
                </IconMenu>
                </div>
                </div>
                <Divider/>
              </div>
            ))
        }
      </List>
    </div>
  )
};

export default ReportList;


// WEBPACK FOOTER //
// ./src/screens/mission-view/report-list.js